import {Component, OnChanges, OnInit} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {AuditLog} from '@iana-rzms/bff-sdk';

@Component({
    selector: 'lib-user-audit-log',
    templateUrl: './user-audit-log.component.html',
    styleUrls: ['./user-audit-log.component.scss'],
    standalone: false
})
export class UserAuditLogComponent implements OnChanges, OnInit {

  auditLog: AuditLog[];

  constructor(private userService: UserService) {
  }

  ngOnChanges(changes: any): void {

  }

  ngOnInit() {
    this.userService.retrieveCurrentUserAuditLog().subscribe(data => {
      this.auditLog = data;
    }, error => {
      console.log(error);
    })
  }

}
